var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85714 0.795455C5.03571 0.30303 5.46429 0 5.92857 0H10.0714C10.5357 0 10.9643 0.30303 11.1429 0.795455L11.7143 2.42424H15.1429C15.6071 2.42424 16 2.84091 16 3.33333C16 3.82576 15.6071 4.24242 15.1429 4.24242H0.857143C0.392857 4.24242 0 3.82576 0 3.33333C0 2.84091 0.392857 2.42424 0.857143 2.42424H4.28571L4.85714 0.795455ZM1.85714 17.7652L1.03571 6.06061H2.75L3.57143 17.6136C3.57143 17.9545 3.82143 18.1818 4.14286 18.1818H11.8929C12.1786 18.1818 12.4286 17.9545 12.4643 17.6136L13.25 6.06061H14.9643L14.1429 17.7652C14.0714 19.0152 13.0714 20 11.8929 20H4.14286C2.92857 20 1.92857 19.0152 1.85714 17.7652Z",
    fill: "#FF3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.0611919eeb0686036d751da703aae272.svg";
export { ForwardRef as ReactComponent };